<template>
  <div>
    <d-form-row class="form-group">
      <d-col cols="12" class="mb-3">
        <label class="d-flex align-items-center">Escolha um jogo: <a :href="`${crosswordUrl}admin/jogo/novo`" target="_blank" class="p-1 ml-3 btn-outline-info btn-sm">Criar novo jogo no sistema</a></label>
        <autocomplete
          ref="crosswords_search"
          placeholder="Buscar jogos palavras cruzadas"
          :items="puzzles"
          item-show="name"
          :on-input="onInputPuzzle"
          :on-select="setPuzzle"
        ></autocomplete>
      </d-col>
    </d-form-row>
    <d-form-row v-if="model.data.name">
      <d-col cols="12">
        <h5>{{ model.data.name }}</h5>
      </d-col>
    </d-form-row>
    <div
      v-if="model.data.table"
      class="puzzle"
      :style="{
        'grid-template-rows': `repeat(${model.data.rows}, ${cellSize}px)`,
        'grid-template-columns': `repeat(${model.data.columns}, ${cellSize}px)`,
      }"
    >
      <puzzle-cell
        v-for="(cell, index) in model.data.table"
        :key="`${cell.positiony} + ${cell.positionx}`"
        :cell="cell"
        :index="index"
      />
    </div>
    <modal-login/>
  </div>
</template>

<script>
import { cloneDeep } from '_utils';
import { mapActions } from 'vuex';
import config from '_config';
import Autocomplete from '_shared/Autocomplete.vue';
import CrosswordsService from '_services/rest/modules/crossword';
import ModalLogin from './LoginModal.vue';
import PuzzleCell from './PuzzleCell.vue';
import { MODEL } from '../../PuzzleModel';

const data = {
  name: '',
  rows: 1,
  table: [],
  columns: 1,
};
const PUZZLE = { ...MODEL, ...{ data } };

export default {
  name: 'Cross-words-puzzle',
  components: {
    Autocomplete,
    PuzzleCell,
    ModalLogin,
  },
  props: {
    model: {
      type: Object,
      require: true,
      default: () => cloneDeep(PUZZLE),
    },
  },
  data() {
    return {
      puzzles: [],
    };
  },
  computed: {
    crosswordUrl() {
      return config.FRONT_CROSSWORD_URL;
    },
    cellSize() {
      return this.isMobile ? 50 : 70;
    },
    isMobile() {
      if (process.browser) {
        return window.innerWidth < 768;
      }
      return true;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
    ]),
    onInputPuzzle(name) {
      clearTimeout(this.searchTimeoutId);
      this.searchTimeoutId = setTimeout(() => {
        this.getPuzzles(name);
      }, 500);
    },
    getPuzzles(params) {
      CrosswordsService.getPuzzles(params)
        .then(response => {
          this.puzzles = response.data;
        })
        .catch(error => {
          if (error.response.status === 401) {
            this.setToggle({ type: 'login_modal', bool: true });
          }
        });
    },
    setPuzzle(puzzle) {
      this.model.data = {
        name: puzzle.name,
        rows: puzzle.rows,
        table: puzzle.table,
        columns: puzzle.columns,
      };
      this.$emit('update:model', this.model);
    },
  },
};
</script>

<style lang="scss" scoped>
.input_arrow {
  width: 50px;
  justify-content: space-between;
  align-items: center;
  margin-right: 15px;
}
.puzzle {
  display: inline-grid;
  grid-auto-rows: 70px;
  grid-auto-columns: 70px;
  font-size: 8px;
  margin-left: 1px;
  border: 2px solid #333;
}
.arrows {
  &.top {
    transform: rotate(180deg);
  }
  &.right {
    transform: rotate(-90deg);
  }
  &.bottom {

  }
  &.left {
    transform: rotate(90deg);
  }
  &.top_left {
    transform: rotate(130deg);
  }
  &.top_right {
    transform: rotate(-130deg);
  }
  &.bottom_left {
    transform: rotate(45deg);
  }
  &.bottom_right {
    transform: rotate(-45deg);
  }
}
</style>
